module.exports = __webpack_public_path__ + "static/media/product-4-side.9b7fae07.jpg";